import { Component } from '@angular/core';
import { UnitMeasureService } from '../../unit-measure.service';
import {
  IUnitMeasure,
  UNIT_MEASURE_GROUP_TTL_ES
} from '../../unit-measure.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-unit-measure',
  templateUrl: './unit-measure.component.html'
})
export class UnitMeasureComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: UnitMeasureService) {
    super(UNIT_MEASURE_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: UNIT_MEASURE_GROUP_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'description' },
        { header: 'Abreviatura', field: 'symbol' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IUnitMeasure[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
